import { render, staticRenderFns } from "./ProviderDescriptionForm.vue?vue&type=template&id=7d8966aa&scoped=true&v-if=internal&"
import script from "./ProviderDescriptionForm.vue?vue&type=script&lang=ts&"
export * from "./ProviderDescriptionForm.vue?vue&type=script&lang=ts&"
import style0 from "./ProviderDescriptionForm.vue?vue&type=style&index=0&id=7d8966aa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d8966aa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
